import React from "react";
import { MessageBar, MessageBarType } from "@fluentui/react";

const NoteComponent = ({ message, isMultiline, onDismiss }) => {
  return (
    <MessageBar
      messageBarType={MessageBarType.info}
      isMultiline={isMultiline ? isMultiline : false}
      dismissButtonAriaLabel={onDismiss ? "Close" : undefined}
      onDismiss={onDismiss}
      className="my-1"
    >
      {message}
    </MessageBar>
  );
};

export default NoteComponent;
